import NavBar from "../generalComponents/NavBar";
import TextfieldSimple from "../generalComponents/TextInputField/TextfieldSimple";
import { useEffect, useReducer, useState } from "react";
import PrioField from "../generalComponents/PrioField";
import TypeOfInstitutionComponent from "./components/TypeOfInstitutionComponent";
import { API_ENDPOINTS } from "../config";
import { useParams } from "react-router-dom";
import fetch from "node-fetch";
import ImageUploadComponent from "./components/ImageUploadComponent";
import { IMGTYPES } from "../imgUploadConfig";
import AdressCustomerComponent from "./components/AdressCustomerComponent";
import ListOfAdressCustomerComponents from "./components/ListOfAdressCustomerComponents";

const initialState = {
    institutionName: '',
    institutionLink: '',
    institutionImage: '',
    institutionPrio: '',
    institutionType: 'Practise',
};

function reducer(state, action) {
    switch (action.type) {
        case 'SET_REFERENCE_DATA':
            return { ...state, ...action.payload };
        case 'SET_REFERENCE_IMAGE':
            return { ...state, institutionImage: action.payload.image };
        case 'SET_REFERENCE_TYPE':
            return { ...state, institutionType: action.payload };
        case 'RESET_REFERENCE_DATA':
            return initialState;
        default:
            return state;
    }
}

const typeOfInstitutionByID = {
    "c074b60abb80dd452afb4f70b31b73e1": "Clinic",
    "a3d7f1ab24201346924d6e8da98c0e29": "Practise",
    "7ca10110a5bba003c5c4e7677ed16fe9": "Media",
    "fd69e3b3b8bdd2dc3e12a04c06468f4b": "Partner",
    "bf97f3d3db0087601ae83b59aa81a8c7": "Other"
};

const IDForInstitution = {
    "Clinic": "c074b60abb80dd452afb4f70b31b73e1",
    "Practise": "a3d7f1ab24201346924d6e8da98c0e29",
    "Media": "7ca10110a5bba003c5c4e7677ed16fe9",
    "Partner": "fd69e3b3b8bdd2dc3e12a04c06468f4b",
    "Other": "bf97f3d3db0087601ae83b59aa81a8c7"
};

const useFetchReferenceDetails = (id) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchReferenceDetails = async () => {
                setIsFetching(true);
                const token = localStorage.getItem('token');
                const url = `${API_ENDPOINTS.getSingleReference}/${id}`;
                const options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                };

                const response = await fetch(url, options);

                if (response.ok) {
                    const fetchData = await response.json();
                    const customerReferenceData = fetchData.fieldData;

                    const customerPrioFieldName = customerReferenceData["customer-relevance-1-2-3-1-top"];
                    const customerWebsiteFieldName = customerReferenceData["customer-website"];
                    const typOfReference = typeOfInstitutionByID[customerReferenceData["type-of-reference"]];

                    dispatch({
                        type: 'SET_REFERENCE_DATA',
                        payload: {
                            institutionName: customerReferenceData.name || '',
                            institutionLink: customerWebsiteFieldName || '',
                            institutionPrio: customerPrioFieldName || '',
                            institutionType: typOfReference || '',
                            institutionAdress: customerReferenceData.institutionAdress || '',
                            institutionImage: customerReferenceData.logo.url || '',
                        }
                    });
                }
                setIsFetching(false);
            };
            fetchReferenceDetails();
        }
    }, [id]);

    return { state, dispatch, isFetching };
};

const CustomerReferenceForm = () => {
    const { id } = useParams();
    const { state, dispatch, isFetching } = useFetchReferenceDetails(id);

    const isExistingReference = !!id;

    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [isSubmittingReference, setIsSubmittingReference] = useState(false);
    const [successfulSubmission, setSuccessfulSubmission] = useState(false);
    const [hasEncounteredError, setHasEncounteredError] = useState(false);

    const resetValues = () => {
        dispatch({ type: 'RESET_REFERENCE_DATA' });
    };

    const handleReferenceDataChange = (value, field) => {
        dispatch({ type: 'SET_REFERENCE_DATA', payload: { [field]: value } });
        setSuccessfulSubmission(false);
    };

    const handleReferenceImageChange = (value) => {
        dispatch({ type: 'SET_REFERENCE_IMAGE', payload: { image: value } });
    };

    const handleReferenceTypeChange = (value) => {
        const type = IDForInstitution[value];
        dispatch({ type: 'SET_REFERENCE_TYPE', payload: type });
    };

    const handleReferenceTypeUpdateNoConversion = (value) => {
        dispatch({ type: 'SET_REFERENCE_TYPE', payload: value });
    };

    const handleSubmitOrUpdate = async (event) => {
        event.preventDefault();
        if (id) {
            await handleUpdateReference(event);
        } else {
            await handleSubmitReference(event);
        }
    };

    const handleUpdateReference = async (event) => {
        setIsSubmittingReference(true);
        const token = localStorage.getItem('token');

        const data = {
            customername: state.institutionName,
            slug: generateSlug(state.institutionName),
            logo: {
                alt: null,
                url: state.institutionImage
            },
            link: state.institutionLink,
            reference: state.institutionType,
            relevance: state.institutionPrio
        };

        try {
            const response = await fetch(`${API_ENDPOINTS.postReferences}/${id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                setIsSubmittingReference(false);
                setSuccessfulSubmission(true);
                resetValues();
            } else {
                console.error("Response not OK");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleSubmitReference = async (event) => {
        setIsSubmittingReference(true);
        const token = localStorage.getItem('token');

        const data = {
            customername: state.institutionName,
            slug: generateSlug(state.institutionName),
            logo: {
                alt: null,
                url: state.institutionImage
            },
            link: state.institutionLink,
            reference: state.reference,
            relevance: state.institutionPrio.toString()
        };

        try {
            const response = await fetch(API_ENDPOINTS.postReferences, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                setIsSubmittingReference(false);
                setSuccessfulSubmission(true);
                resetValues();
            } else {
                console.error("Response not OK");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const generateSlug = (title) => {
        return title
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-_]/g, '')
            .replace(/-+/g, '-');
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <NavBar />
            <div className="container mx-auto py-6">
                {isSubmittingReference && (
                    <div className="text-center">
                        <h1 className="text-2xl font-bold">Submitting Reference to Web</h1>
                    </div>
                )}
                {successfulSubmission && (
                    <div className="text-center">
                        <h2 className="text-xl text-green-600">Reference {state.institutionName} was successfully submitted!</h2>
                    </div>
                )}
                {isFetching && (
                    <div className="text-center">
                        <h2 className="text-xl">Fetching data...</h2>
                    </div>
                )}
                {!isSubmittingReference && !isFetching && (
                    <div>
                    <div className="bg-gray-200 shadow-md rounded-lg p-6 mb-4">
                        <form onSubmit={handleSubmitOrUpdate}>
                            <h1 className="text-3xl font-bold mb-4">Upload and edit reference logos </h1>
                            <div className="grid grid-cols-1 gap-6">
                                <TextfieldSimple
                                    value={state.institutionName || ''}
                                    OnChangeValue={(data) => handleReferenceDataChange(data, 'institutionName')}
                                    label="Name of institution:"
                                    className="mb-4"
                                />
                                <TextfieldSimple
                                    value={state.institutionLink || ''}
                                    OnChangeValue={(data) => handleReferenceDataChange(data, 'institutionLink')}
                                    label="Link To Institution"
                                    className="mb-4"
                                />
                                <PrioField
                                    value={state.institutionPrio || ''}
                                    OnChange={(data) => handleReferenceDataChange(data.target.value, 'institutionPrio')}
                                    className="mb-4"
                                />
                                <TypeOfInstitutionComponent
                                    value={state.institutionType || ''}
                                    onChange={(data) => handleReferenceTypeUpdateNoConversion(data.target.value)}
                                    className="mb-4"
                                />
                                <ImageUploadComponent
                                    IMGTYPE={IMGTYPES.reference}
                                    onImageUpload={(img) => handleReferenceImageChange(img)}
                                    image={state.institutionImage}
                                    className="mb-4"
                                />
                                {state.institutionName && state.institutionImage && (
                                    <button
                                        type="submit"
                                        className="w-52 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition"
                                    >
                                        {isExistingReference ? 'Update Reference' : 'Submit Reference'}
                                    </button>
                                )}
                            </div>
                        </form>
                        
                    </div>
                        {id && 
                    <div className={"bg-gray-200 shadow-md rounded-lg p-6 mb-4"}>
                        <h1 className="text-3xl font-bold mb-4">Edit reference addresses for the map </h1>
                        <ListOfAdressCustomerComponents
                            customerID={state.institutionName} id={id}></ListOfAdressCustomerComponents>
                    </div>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomerReferenceForm;
